/* eslint-disable @next/next/no-img-element */
import React from "react";

import { currentLocaleAtom } from "@keepeek/commons";
import { BaseComponentProps } from "@keepeek/refront-components";
import { Box } from "@mui/material";
import clsx from "clsx";
import { useRecoilValue } from "recoil";

import {
  KVideoWidget,
  Resource,
} from "../../../../../models/configuration/components/kVideoWidget";

const WidgetCardSelectorVideo = function ({
  testId = "WidgetCardSelectorVideo",
  className,
  controlsTitle,
  kVideoWidgetVideo,
  id,
}: KVideoWidget & BaseComponentProps) {
  const { loop, autoPlay, poster } = controlsTitle || {};
  const currentLocale = useRecoilValue(currentLocaleAtom);
  let videoSrc =
    kVideoWidgetVideo && kVideoWidgetVideo.url?.find((u) => u.language === currentLocale)?.value;
  const resource: Resource | undefined = kVideoWidgetVideo?.url?.find(
    (u) => u.language === currentLocale,
  )?.resource;
  if (resource && resource.url) {
    videoSrc = resource.url;
  }
  const posterResource =
    (kVideoWidgetVideo &&
      kVideoWidgetVideo.posterResource?.find((u) => u.language === currentLocale)?.resource?.url) ||
    poster;

  return (
    <Box
      className={clsx("WidgetCardSelectorVideo", className)}
      style={{ height: "100%", width: "100%" }}
      data-testid={testId}
      title={id}
    >
      {!!videoSrc && (
        <video
          // Need a key here to reload video component on video url change (can happen during a change from the frontedit)
          key={`${videoSrc}-${posterResource}-${loop}-${autoPlay}`}
          src={videoSrc}
          poster={posterResource}
          style={{ height: "100%", width: "100%" }}
          muted
          loop={loop}
          autoPlay={autoPlay}
        />
      )}
    </Box>
  );
};

export default WidgetCardSelectorVideo;
